import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Game } from '../models/game';
import { ConfigService } from '../services/config.service';
import { HandballGameLog } from '../models/handball-game-log';
import { HandballGameStatistic } from '../models/handball-game-statistic';
import { HandballGameTeamStatistic } from '../models/handball-game-team-statistic';
import { GameBaseApi } from './game-base-api';

@Injectable({providedIn: 'root'})
export class HandballGameApi extends GameBaseApi {
  constructor(
    protected httpClient: HttpClient,
    protected configService: ConfigService
  ) {
    super(httpClient, configService);
  }

  async getById(gameId: number): Promise<Game> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_handball_game/${gameId}/`).pipe(
      map(result => Game.toFront(result))
    ).toPromise();
  }

  async getTeamStatistic(gameId: number): Promise<HandballGameTeamStatistic> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_handball_game/${gameId}/team_statistic/`).pipe(
      map(result => HandballGameTeamStatistic.toFront(result))
    ).toPromise();
  }

  async getUserStatistic(gameId: number): Promise<HandballGameStatistic[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_handball_game/${gameId}/user_statistic/`).pipe(
      map(result => HandballGameStatistic.toFront(result))
    ).toPromise();
  }

  async getLogs(gameId: number): Promise<HandballGameLog[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_handball_game/${gameId}/logs/`).pipe(
      map(result => HandballGameLog.toFront(result))
    ).toPromise();
  }

  async downloadProtocol(gameId: number, format: 'pdf' | 'xlsx' | 'html'): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_handball_game/${gameId}/game_protocol/`, {
      params: new HttpParams().set('file_type', format),
      responseType: 'blob'
    }).toPromise();
  }

  async downloadApplication(gameId: number, format: 'pdf' | 'xlsx' | 'html', type: 'game_user' | 'tournament_user'): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_handball_game/${gameId}/game_application_file/`, {
      params: new HttpParams().set('file_type', format).set('application_type', type),
      responseType: 'blob'
    }).toPromise();
  }
}
